/**
 * Vertical Steps Widget - Intersection Observer Animation
 * Changes .step-jaartal background color when scrolled to 50% viewport
 */
( function() {
    'use strict';

    function initStepsVertical() {
        const stepsContainers = document.querySelectorAll( '.vertical-steps' );
        if ( ! stepsContainers.length ) {
            return;
        }

        // Observer for .text items (animate on intersection)
        const observer = new IntersectionObserver( ( entries ) => {
            entries.forEach( ( entry ) => {
                if ( entry.isIntersecting ) {
                    entry.target.classList.add( 'animate' );
                } else {
                    entry.target.classList.remove( 'animate' );
                }
            } );
        }, {
            threshold: 0.5,
        } );

        // Observer for .step-getal elements (color change when at 50% of window height)
        const observedGetals = new Set();
        const visibleGetals = new Set();

        const getalObserver = new IntersectionObserver( ( entries ) => {
            entries.forEach( ( entry ) => {
                // Skip first intersection on page load
                if ( ! observedGetals.has( entry.target ) ) {
                    observedGetals.add( entry.target );
                    return;
                }

                // Add class only once when element reaches 50% of window height
                if ( entry.isIntersecting && ! visibleGetals.has( entry.target ) ) {
                    entry.target.classList.add( 'is-visible' );
                    visibleGetals.add( entry.target );
                }
            } );
        }, {
            rootMargin: '-50% 0px -50% 0px',
            threshold: 0,
        } );

        stepsContainers.forEach( ( container ) => {
            // Observe .text items for animation
            container.querySelectorAll( '.text' ).forEach( ( item ) => {
                observer.observe( item );
            } );

            // Observe .step-getal items for color change
            container.querySelectorAll( '.step-getal' ).forEach( ( getal ) => {
                getalObserver.observe( getal );
            } );
        } );
    }
    // Initialize on DOM ready
    if ( document.readyState === 'loading' ) {
        document.addEventListener( 'DOMContentLoaded', initStepsVertical );
    } else {
        initStepsVertical();
    }
    
    // Reinitialize on responsive resize
    window.addEventListener('responsiveResize', initStepsVertical);
    
    // Re-initialize on Elementor live edit
    if ( window.elementorFrontend ) {
        window.elementorFrontend.hooks.addAction(
            'frontend/element_ready/db_steps-vertical.default',
            initStepsVertical
        );
    }
} )();